//
// SelectStrediskaModalWindow.ts
//
// Modální okno pro multi výběr ze seznamu středisek spisových uzlů
// Voláno z 
//  GStrediskaTab.ts

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SelectStrediskaModalWindow extends GContentBase {
        private grid: JQuery<HTMLElement>;

        addStrediska() {
            var selectedData = this.grid.ggrid("getSelection")
            this.close(selectedData);
        }

        onContentReady() {
            this.grid = $("<div>").appendTo(this.element).ggrid({
                multi: true,
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:32131029",
                    })
            }).gautofit();

            new Gordic.Data.Readers.Ginstre().getData().done((str) => {
                this.grid.ggrid("setData", str);
            })
        }
    }
}